module.exports = __webpack_public_path__ + "assets/details-usd.03ce6634.svg";